import { render, staticRenderFns } from "./card-num-stat.vue?vue&type=template&id=468b343d&scoped=true&"
import script from "./card-num-stat.vue?vue&type=script&lang=js&"
export * from "./card-num-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b343d",
  null
  
)

export default component.exports